import Vue from "vue";
import Util from "@/util";

const API_URL = "/app/";

const state = {
  authenticated: !!Util.ls.get("token"),
  token: Util.ls.get("token"),
  role: Util.ls.get("role"),
  profil: {}
};

const mutations = {
  LOGIN(state, token) {
    state.authenticated = true;
    state.token = token;
  },
  LOGOUT(state) {
    state.authenticated = false;
    state.token = "";
  },
  SET_ROLE(state, payload) {
    state.role = payload;
  },
  SET_PROFIL(state, payload) {
    state.profil = payload;
  }
};

const actions = {
  RESOLVE_HASH({ commit }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL + "resolve_hash", payload)
      .then(() => {
        commit("SUCCESS", "Kredensial valid, silahkan ganti password Anda.", {
          root: true
        });
      })
      .catch(e => {
        commit("ERROR", "Oopss, sesuatu bermasalah!", {
          root: true
        });
        throw e;
      });
  },
  RESET_PASSWORD({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL + "reset_password", payload)
      .then(() => {
        commit("SUCCESS", "Berhasil mengupdate...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, { root: true });
        throw e;
      });
  },
  LUPA_PASSWORD({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL + "lupa_password", payload)
      .then(() => {
        commit("SUCCESS", "Berhasil, silahkan cek E-Mail Anda.", {
          root: true
        });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  LOGOUT({ commit }) {
    Util.ls.remove("token");
    commit("LOGOUT");
  },
  LOGIN({ commit, rootState }, payload) {
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL, payload)
      .then(res => {
        Util.ls.set("token", res.data.token);
        Util.ls.set("role", res.data.user.role);
        commit("LOGIN", res.data.token);
        commit("SET_PROFIL", res.data.user);
        commit("SET_ROLE", res.data.user.role);
        commit("laman/SET_LAMAN", res.data.laman, { root: true });
        commit("sistem/SET_SISTEM", res.data.sistem, { root: true });
        commit(
          "SUCCESS",
          `Selamat datang kembali <b>${res.data.user.username}</b>`,
          {
            root: true
          }
        );
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  },
  RESOLVE_TOKEN({ commit }) {
    commit("LOADING", null, { root: true });
    return Vue.axios.get(API_URL).then(res => {
      commit("SET_PROFIL", res.data.user);
      commit("laman/SET_LAMAN", res.data.laman, { root: true });
      commit("sistem/SET_SISTEM", res.data.sistem, { root: true });
      commit("LOADING_DONE", null, { root: true });
    });
  },
  UPDATE_PROFIL({ commit, rootState }, payload) {
    // prepare the data
    let options = {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: function(progressEvent) {
        var percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        commit("UPLOAD_PROGRESS", percentCompleted, { root: true });
      }
    };
    let formData = new FormData();
    formData.append("photo_profil", payload.image);
    formData.append("json_data", JSON.stringify(payload.form));
    // request
    commit("PROCESSING", true, { root: true });
    commit("LOADING", null, { root: true });
    return Vue.axios
      .post(API_URL + "profil/" + payload.form.id_user, formData, options)
      .then(res => {
        Util.ls.set("token", res.data.token);
        commit("LOGIN", res.data.token);
        commit("SET_PROFIL", res.data.user);
        commit("SUCCESS", "Berhasil mengupdate...", { root: true });
      })
      .catch(e => {
        commit("PROCESSING", false, { root: true });
        if (!rootState.status.message)
          commit("LOADING_DONE", null, {
            root: true
          });
        throw e;
      });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
